import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import PasswordInput from "../components/PasswordInput";
import storage from '../nativeStorage';

export default function SuperAdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setLoading(true); setError("");
    try {
      const res = await api.post("/auth/login", { email, password });
      if (!res.data.superadmin) { setError("Invalid super admin credentials"); setLoading(false); return; }
      storage.setItem("token", res.data.token);
      storage.setItem("superadmin", "true");
      window.location.href = res.data.must_change_password ? "/change-password?forced=true" : "/superadmin/dashboard";
    } catch(e) { setError("Invalid credentials"); setLoading(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#1e1b4b", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
      <div style={{ background: "#312e81", borderRadius: "12px", padding: "36px 32px", width: "100%", maxWidth: "380px", boxShadow: "0 8px 32px rgba(0,0,0,0.4)" }}>
        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <div style={{ fontSize: "36px", marginBottom: "8px" }}>🔑</div>
          <h1 style={{ color: "white", fontSize: "18px", fontWeight: "800", margin: 0 }}>System Administration</h1>
          <p style={{ color: "#a5b4fc", fontSize: "12px", marginTop: "4px" }}>Authorised access only</p>
        </div>
        {error && <div style={{ background: "#fef2f2", color: "#b91c1c", padding: "10px 14px", borderRadius: "8px", fontSize: "13px", marginBottom: "16px" }}>{error}</div>}
        <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
          <div>
            <label style={{ fontSize: "12px", fontWeight: "600", color: "#c7d2fe", display: "block", marginBottom: "4px" }}>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === "Enter" && handleSubmit()}
              style={{ width: "100%", border: "1px solid #4f46e5", background: "#1e1b4b", color: "white", borderRadius: "8px", padding: "10px 12px", fontSize: "14px", boxSizing: "border-box" }} />
          </div>
          <div>
            <label style={{ fontSize: "12px", fontWeight: "600", color: "#c7d2fe", display: "block", marginBottom: "4px" }}>Password</label>
            <PasswordInput value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === "Enter" && handleSubmit()}
              style={{ width: "100%", border: "1px solid #4f46e5", background: "#1e1b4b", color: "white", borderRadius: "8px", padding: "10px 12px", fontSize: "14px", boxSizing: "border-box" }} />
          </div>
          <button onClick={handleSubmit} disabled={loading}
            style={{ background: "#4f46e5", color: "white", border: "none", borderRadius: "8px", padding: "12px", fontSize: "14px", fontWeight: "700", cursor: "pointer", opacity: loading ? 0.7 : 1 }}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
          <button onClick={() => navigate("/choose-login")}
            style={{ background: "none", border: "none", color: "#a5b4fc", fontSize: "12px", cursor: "pointer" }}>
            ← Back
          </button>
        </div>
      </div>
    </div>
  );
}
